import { Grid, Typography } from '@mui/material';
import { FC } from 'react';
import { ModelTypeLogo } from '@components/search';
import { AllContentType } from '@utils/types/search';

interface BlockTitleProps {
    modelType: AllContentType;
    modelTypeLabel?: string;
    title: string;
}

const BlockTitle: FC<BlockTitleProps> = ({ modelType, modelTypeLabel, title }) => (
    <Grid
        sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            pb: 2,
            pt: 1,
        }}
    >
        <Typography component="h3" sx={{ m: 0 }}>
            <ModelTypeLogo label={modelTypeLabel} modelType={modelType} />
        </Typography>
        <Typography variant="body2">{title}</Typography>
    </Grid>
);
export default BlockTitle;
